import './carga.css'
import { useCallback, useState } from 'react';
import VerTodoDenuncia from './VerTodoDenuncia';
import sharepoint from '../../images/sharepoint.jpeg'
import sharepointRojo from '../../images/shareRojo.png'
import MenuIzquierdo from '../general/MenuIzquierdo';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import ActualizarDenuncia from './ActualizarDenuncia';
import { PDFDownloadLink } from "@react-pdf/renderer";
import FrentePdf from "../pdf/Frente";
import PDF from "../pdf/Sicobe";
import PlanillaReclamos from "../carga/PlanillaReclamos";
export default function QnxSeccion({ denuncia, frente, sicobe, pagosAnteriores, cobert, carga2, reclamo, carga4 }) {
    const [cookies] = useCookies(["user"], ['asignado']);
    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    }
    const qnxInic = formatDate(denuncia?.qnx?.ados_fech_ini);
    const qnxFin = formatDate(denuncia?.qnx?.ados_fech_fin);
    const [botonOff, setBotonOff] = useState(0)
    const handleLinkClick = (event) => {
        if (!denuncia.link.startsWith('http')) {
            event.preventDefault();
            window.open(`https://${denuncia.link}`, '_blank');
        }
    };
    const logo = { height: '26px', width: '26px' }
    const [link1, setLink1] = useState({ link: denuncia?.link });
    const linkUpdate = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(`https://back.agsseguros.online/api/denuncia/linkSharepoint`,
            {
                id: denuncia.id,
                link: link1.link,
            }
        ).then((response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [denuncia, link1]);
    const openInNewTab = (url, e) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    return (
        <>
            <section className="infoStroTabla1">
                <div className="d-flex justify-content-between align-items-center">
                    <h2 className="tituloStroTabla2 m-0 p-0">Base AGS</h2>
                    <div className="d-flex align-items-center gap-2">
                        {carga2 ?
                            <PDFDownloadLink document={<FrentePdf denuncia={frente} />} fileName={`frenteStro${denuncia?.nroStro?.toString().substring(3)}.pdf`} style={{ textDecoration: 'none' }}>
                                {({ loading, url, error, blob }) =>
                                    <div className='center'><button id="botonFrente" className='btnVerTodo3Stro'>Desc. Frente</button></div>}
                            </PDFDownloadLink>
                            : null}
                        {carga2 && denuncia.nroStro ?
                            <PDFDownloadLink document={<PDF sicobe={sicobe} pagosAnteriores={pagosAnteriores} cobert={cobert} />} style={{ textDecoration: 'none' }} fileName={`sicobeStro${denuncia?.nroStro?.toString().substring(3)}.pdf`}>{({ loading, url, error, blob }) =>
                                <div className='center'><button id="botonSicobe" className='btnVerTodo3Stro'>Desc. Sicobe</button></div>}
                            </PDFDownloadLink>
                            : null}
                        <div className='center'><button class="btnVerTodo1Stro" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight0" aria-controls="offcanvasRight0">P.Reclamos</button></div>
                        <div class="offcanvas offcanvas-end w-75" tabindex="-1" id="offcanvasRight0" aria-labelledby="offcanvasRightLabel0">
                            <div class="offcanvas-header">
                                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div class="offcanvas-body pe-5 ps-5">
                                <PlanillaReclamos reclamo={reclamo} carga4={carga4} denuncia={denuncia} />
                            </div>
                        </div>
                        <div className='center'><button class="btnVerTodo1Stro" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight1" aria-controls="offcanvasRight1">Ver Todo</button></div>
                        <div class="offcanvas offcanvas-end w-75" tabindex="-1" id="offcanvasRight1" aria-labelledby="offcanvasRightLabel1">
                            <div class="offcanvas-header">
                                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div class="offcanvas-body pe-5 ps-5">
                                <VerTodoDenuncia denuncia={denuncia} />
                            </div>
                        </div>
                        <div className='center'><button class="btnVerTodo1Stro" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Editar</button></div>
                        <div class="offcanvas offcanvas-end w-75" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                            <div class="offcanvas-header">
                                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div class="offcanvas-body pe-5 ps-5">
                                <ActualizarDenuncia />
                            </div>
                        </div>
                        {denuncia.link !== null ?
                            <div className='center'>
                                <a href={`${denuncia.link}`} target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>
                                    <img src={sharepoint} alt="" style={logo} />
                                </a>
                            </div> :
                            <div className='center'>
                                <button className='btnNO' data-bs-toggle="modal" data-bs-target="#exampleModal">
                                    <img src={sharepointRojo} alt="" style={logo} />
                                </button>
                            </div>}
                        <div class="modal fade mt-5" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Link Sharepoint</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        <input type="text" className='w-100 ps-3' onChange={(e) =>
                                            setLink1((prevState) => ({
                                                ...prevState,
                                                link: e.target.value,
                                            }))} />
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                                        <button type="button" class="btn btn-primary" onClick={(e) => linkUpdate(e)}>Actualizar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {denuncia.nroStro !== null ?
                            <div className=''>
                                <a href={`https://ags.webmanager.com.ar/LinkAuth/${cookies.user.digi}/QWdzbmV0MDgxMQ==/${denuncia.nroStro.toString().substring(3)}`} target="_blank"><i class="bi bi-file-earmark-text" style={{ fontSize: '26px', color: '#42C3BA' }}></i></a>
                            </div> : <></>}
                    </div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="labelStro">Vigencia</label>
                    <div className="inputStroVigencia d-flex align-items-center text-danger ">
                        <div className="row w-100">
                            <div className="col-6">
                                <p className="m-0 textoCarga">{qnxInic}</p>
                            </div>
                            <div className="col-6">
                                <p className="m-0 textoCarga">{qnxFin}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="labelStro">Poliza</label>
                    <div className="inputStroVigencia d-flex align-items-center textoCarga">
                        <Link onClick={(e) => openInNewTab(`https://www.agsnet.com.ar/muestro-polizas2.php?prop=${denuncia?.qnx?.ados_nro_cc}&rtn=consulta-polizas`)}>{denuncia?.qnx?.ados_poliza}</Link>
                    </div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="labelStro">Nombre</label>
                    <div className="inputStroVigencia d-flex align-items-center textoCarga">
                        {denuncia?.qnx?.ados_nom_aseg}
                    </div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="labelStro">Patente</label>
                    <div className="inputStroVigencia d-flex align-items-center textoCarga">
                        {denuncia?.qnx?.ados_patente}
                    </div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="labelStro">Marca</label>
                    <div className="inputStroVigencia d-flex align-items-center textoCarga">
                        {`${denuncia?.qnx?.ados_vehiculo} - ${denuncia?.qnx?.ados_modelo}`}
                    </div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="labelStro">Modelo</label>
                    <div className="inputStroVigencia d-flex align-items-center textoCarga">
                        {denuncia?.qnx?.ados_modelo}
                    </div>
                </div>
                <div className="mt-5 center gap-4">
                    <div className='center'><button onClick={(e) => setBotonOff(1)} className='btnVerTodo2Stro center'>Frente</button></div>
                    <div className='center'><button onClick={(e) => setBotonOff(2)} className='btnVerTodo2Stro center'>Pagos</button></div>
                    <div className='center'><button onClick={(e) => setBotonOff(3)} className='btnVerTodo2Stro center'>Siniestros</button></div>
                    <div className='center'><button onClick={(e) => setBotonOff(4)} className='btnVerTodo2Stro center'>Endosos</button></div>
                </div>
            </section>
            {botonOff !== 0 ? <MenuIzquierdo botonOff={botonOff} setBotonOff={setBotonOff} denuncia={denuncia} /> : <></>}
        </>
    );
}
